export default __webpack_public_path__ + "static/AdelleSans-Light-72da0504a28f91f6198225ed66249f01.woff2";